import * as React from 'react';
import * as ReactDOM from 'react-dom'
import {MobileNavbar} from "./MobileNavbar";

ReactDOM.render(<MobileNavbar/>, document.getElementById("mobile-nav"));